export const checkDueDateExpired = (item, exibirPagos=false) => {
  let currentDate = new Date()
  let dateItem = new Date(item.DataVencimento)

  if ((currentDate > dateItem)) {
    return true
  }

  return false
}
